import Layout from 'components/layout/Layout'
import { serverSideTranslations } from 'next-i18next/pages/serverSideTranslations'
import i18nConfig from 'utils/i18nConfig'
import { DEFAULT_NAMESPACES, PRODUCERS_NAMESPACES } from 'constants/i18n'
import ProducerContact from 'features/producer-contact/ProducerContact'
import type { ProducerContactProps } from 'features/producer-contact/types'
import type { SeoProps } from 'components/seo/types'
import { cmsLib } from 'lib'
import { FAQCategories } from 'features/faq-page/types'
import { faqCategoriesSlugs } from 'constants/faq-categories'
import { useTranslation } from 'next-i18next/pages'

const ProducerContactPage = (props: ProducerContactProps) => {
  // i18n
  const { t } = useTranslation('b2b')

  // constants
  const seo: SeoProps = {
    title: t('overview.seo.title'),
    description: t('overview.seo.description')
  }

  return (
    <Layout {...{ seo }}>
      <ProducerContact {...props} />
    </Layout>
  )
}

export const getStaticProps = async ({ locale }) => {
  const faqCategories = await cmsLib.getFaqCategories(faqCategoriesSlugs[FAQCategories.B2B], locale)

  return {
    props: {
      faqCategories,
      ...(await serverSideTranslations(locale, [...DEFAULT_NAMESPACES, 'b2b', ...PRODUCERS_NAMESPACES], i18nConfig))
    },
    revalidate: 600 // re-generate page when a request comes in, once every 10 minutes
  }
}

export default ProducerContactPage
